import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_programas } from "../../config/apiConfig";
import { toast } from "react-toastify";
import { FaPenToSquare, FaRegTrashCan, FaCheck, FaX } from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import "./css/Social.css";

const Programas = () => {
  const [programas, setProgramas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [nuevoPrograma, setNuevoPrograma] = useState({
    nombre: "",
    fechaInicio: "",
    fechaFin: null,
  });
  const [permanente, setPermanente] = useState(false);

  const [editId, setEditId] = useState(null); // _id que se edita
  const [editValues, setEditValues] = useState({
    nombre: "",
    fechaInicio: "",
    fechaFin: "",
  });

  const [deleteId, setDeleteId] = useState(null); // _id a borrar
  const [deleteName, setDeleteName] = useState("");

  // Obtener programas de la API
  useEffect(() => {
    const fetchProgramas = async () => {
      try {
        const res = await fetch(API_programas);
        const data = await res.json();
        // Excluir recursos de empleo (EMP) y formación (FORM)
        const programasReales = data.filter(
          (item) =>
            !item.nombre?.startsWith("(EMP)") &&
            !item.nombre?.startsWith("(FORM)")
        );
        setProgramas(programasReales);
      } catch (error) {
        console.error("Error al cargar programas:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProgramas();
  }, []);

  const handleGuardarPrograma = async () => {
    const { nombre, fechaInicio, fechaFin } = nuevoPrograma;
    if (!nombre || !fechaInicio) {
      toast.error("Nombre y fecha de inicio son obligatorios");
      return;
    }

    try {
      const res = await fetch(API_programas, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nombre,
          fechaInicio: toISO(fechaInicio),
          fechaFin: permanente ? null : fechaFin ? toISO(fechaFin) : null,
        }),
      });

      if (!res.ok) throw new Error();

      const creado = await res.json();
      setProgramas([...programas, creado]);
      setMostrarModal(false);
      setNuevoPrograma({ nombre: "", fechaInicio: "", fechaFin: "" });
      setPermanente(false);
      toast.success("Programa guardado");
    } catch (err) {
      console.error("Error al guardar el programa:", err);
      toast.error("No se pudo guardar el programa");
    }
  };

  const formatearFecha = (iso) =>
    new Date(iso).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

  const toISO = (yyyyMmDd) => new Date(`${yyyyMmDd}T00:00:00`).toISOString();

  const startEdit = (p) => {
    setEditId(p._id);
    setEditValues({
      nombre: p.nombre,
      fechaInicio: p.fechaInicio.slice(0, 10),
      fechaFin: p.fechaFin ? p.fechaFin.slice(0, 10) : "",
      permanente: !p.fechaFin,
    });
  };

  const guardarEdicion = async () => {
    const { nombre, fechaInicio, fechaFin, permanente } = editValues;

    if (!nombre || !fechaInicio) {
      toast.error("Nombre y fecha de inicio son obligatorios");
      return;
    }

    const body = {
      nombre,
      fechaInicio: toISO(fechaInicio),
      fechaFin: permanente ? null : fechaFin ? toISO(fechaFin) : null,
    };

    /* 1 ─ actualiza la tabla inmediatamente  */
    setProgramas(
      programas.map((p) => (p._id === editId ? { ...p, ...body } : p))
    );
    setEditId(null); // salimos de edición

    /* 2 ─ manda el PUT  */
    try {
      const res = await fetch(`${API_programas}/${editId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error();

      const fromApi = await res.json(); // puede venir parcial
      /* 3 ─ mezcla para asegurar consistencia */
      setProgramas((progs) =>
        progs.map((p) => (p._id === editId ? { ...p, ...body, ...fromApi } : p))
      );

      toast.success("Programa actualizado");
    } catch (err) {
      console.error(err);
      toast.error("No se pudo actualizar el programa");
    }
  };

  const cancelarEdicion = () => setEditId(null);

  const borrarPrograma = async () => {
    try {
      const res = await fetch(`${API_programas}/${deleteId}`, {
        method: "DELETE",
      });
      if (!res.ok) throw new Error();

      setProgramas(programas.filter((p) => p._id !== deleteId));
      toast.success("Programa eliminado", { autoClose: 1500 });
    } catch (err) {
      console.error(err);
      toast.error("No se pudo eliminar el programa");
    } finally {
      setDeleteId(null);
    }
  };

  return (
    <>
      <Navbar />

      <main className="main social programas-sociales empleo-formacion tecnicos">
        <button
          onClick={() => setMostrarModal(true)}
          className="boton azul social align-center mb-50 w-content"
        >
          Dar de alta un nuevo programa
        </button>

        <section className="informacion-social column">
          <h1 className="titulo-user mayusculas align-center mb-25">
            Listado de programas existentes
          </h1>

          {loading ? (
            <p>Cargando programas...</p>
          ) : (
            <table className="tabla-programas w-content">
              <thead>
                <tr>
                  <th className="text-left w-400">Nombre del programa</th>
                  <th className="text-left w-175">Fecha de inicio</th>
                  <th className="text-left w-175">Fecha de fin</th>
                  <th className="text-left w100"></th>
                </tr>
              </thead>
              <tbody>
                {programas.map((p) =>
                  editId === p._id ? (
                    // modo edición
                    <tr key={p._id}>
                      <td>
                        <input
                          className="w-350 nombre-programa"
                          value={editValues.nombre}
                          onChange={(e) =>
                            setEditValues({
                              ...editValues,
                              nombre: e.target.value,
                            })
                          }
                        />
                      </td>

                      <td>
                        <input
                          type="date"
                          value={editValues.fechaInicio}
                          aria-label="Fecha de inicio"
                          onChange={(e) =>
                            setEditValues({
                              ...editValues,
                              fechaInicio: e.target.value,
                            })
                          }
                        />
                      </td>

                      <td>
                        {editValues.permanente ? (
                          <span className="gris italic">Permanente</span>
                        ) : (
                          <input
                            type="date"
                            value={editValues.fechaFin}
                            aria-label="Fecha fin"
                            onChange={(e) =>
                              setEditValues({
                                ...editValues,
                                fechaFin: e.target.value,
                              })
                            }
                          />
                        )}
                        <label className="ml-10 align-center gap-5">
                          <input
                            type="checkbox"
                            checked={editValues.permanente}
                            onChange={(e) => {
                              const perm = e.target.checked;
                              setEditValues({
                                ...editValues,
                                permanente: perm,
                                fechaFin: perm ? "" : editValues.fechaFin,
                              });
                            }}
                          />
                          Sin fecha de fin
                        </label>
                      </td>

                      <td className="check flex gap-5">
                        <button
                          className="fondo-blanco verde"
                          aria-label="Guardar cambios"
                          onClick={guardarEdicion}
                        >
                          <FaCheck />
                        </button>
                        <button
                          className="fondo-blanco rojo"
                          aria-label="Cancelar cambios"
                          onClick={cancelarEdicion}
                        >
                          <FaX />
                        </button>
                      </td>
                    </tr>
                  ) : (
                    // fila normal
                    <tr key={p._id}>
                      <td>{p.nombre}</td>
                      <td className="pl-5">{formatearFecha(p.fechaInicio)}</td>
                      <td className="pl-5">
                        {p.fechaFin ? formatearFecha(p.fechaFin) : "Permanente"}
                      </td>

                      <td className="acciones flex gap-15 ml-5">
                        <FaPenToSquare
                          className="icono editar verde cursor"
                          title="Editar programa o fecha"
                          onClick={() => startEdit(p)}
                        />
                        <FaRegTrashCan
                          className="icono eliminar rojo cursor"
                          title="Eliminar programa"
                          onClick={() => {
                            setDeleteId(p._id);
                            setDeleteName(p.nombre);
                          }}
                        />
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          )}
        </section>

        {mostrarModal && (
          <div className="historico-seguimiento">
            <div className="modal-content">
              <div className="modal-header mayusculas">
                <h2>AÑADIR NUEVO PROGRAMA</h2>
              </div>
              <div className="modal-body">
                <div className="campo column w-450 mb-30">
                  <label className="azul mayusculas">
                    Nombre del programa *
                  </label>
                  <input
                    type="text"
                    placeholder="Nombre"
                    value={nuevoPrograma.nombre}
                    onChange={(e) =>
                      setNuevoPrograma({
                        ...nuevoPrograma,
                        nombre: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="campo column w-450 mb-40">
                  <div className="align-start gap-25">
                    <div className="align-center gap-5">
                      <p className="azul">Inicio:</p>
                      <input
                        type="date"
                        required
                        value={nuevoPrograma.fechaInicio}
                        onChange={(e) =>
                          setNuevoPrograma({
                            ...nuevoPrograma,
                            fechaInicio: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="column">
                      <div className="align-center gap-5">
                        <p className="azul fin">Fin:</p>
                        {!permanente ? (
                          <input
                            type="date"
                            value={nuevoPrograma.fechaFin}
                            onChange={(e) =>
                              setNuevoPrograma({
                                ...nuevoPrograma,
                                fechaFin: e.target.value,
                              })
                            }
                          />
                        ) : (
                          <span className="ml-10 italic gris">Permanente</span>
                        )}
                      </div>

                      <label className="align-center gap-5 mt-5">
                        <input
                          type="checkbox"
                          checked={permanente}
                          onChange={(e) => {
                            setPermanente(e.target.checked);
                            if (e.target.checked) {
                              setNuevoPrograma({
                                ...nuevoPrograma,
                                fechaFin: "",
                              });
                            }
                          }}
                        />
                        Sin fecha de fin
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex end gap-10">
                  <button
                    className="boton azul"
                    onClick={() => setMostrarModal(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    className="boton azul"
                    onClick={handleGuardarPrograma}
                  >
                    Añadir
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {deleteId && (
          <div className="ventana-cancelar fondo-blanco">
            <div className="column gap-10">
              <p>
                ¿Eliminar el programa <strong>«{deleteName}»</strong>?<br />
                Una vez eliminado no se puede recuperar.
              </p>

              <div className="botones flex gap-20">
                <button className="fondo-rojo blanco" onClick={borrarPrograma}>
                  Sí
                </button>
                <button
                  className="fondo-verde blanco"
                  onClick={() => setDeleteId(null)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default Programas;
